/**
 * Created by Ivan on 17.05.2026
 */

const SeasonPassWindow = Prefab.createWindow(
    "season_pass_main_window",
    "main_window_prefab_json",
    {
        theme: (mission) => bundles[`season_pass_${mission.logic.period}`].jsons[`theme_${mission.logic.period}`],
        bundles: SeasonPassLogic.listWindowBundles
    }
);
